module.exports = __webpack_public_path__ + "img/mobile-sketches-mobile.83bdd8e3.png";